import { render, staticRenderFns } from "./PcDateController.vue?vue&type=template&id=91c5dd10&scoped=true&"
import script from "./PcDateController.vue?vue&type=script&lang=js&"
export * from "./PcDateController.vue?vue&type=script&lang=js&"
import style0 from "./PcDateController.vue?vue&type=style&index=0&id=91c5dd10&prod&lang=scss&"
import style1 from "./PcDateController.vue?vue&type=style&index=1&id=91c5dd10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c5dd10",
  null
  
)

/* custom blocks */
import block0 from "./PcDateController.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports